// extracted by mini-css-extract-plugin
export default {"wrapper":"AdmissionsFunnel_wrapper__4RsyT","buttonWrap":"AdmissionsFunnel_buttonWrap__eZORy","cancelBtn":"AdmissionsFunnel_cancelBtn__G+5uY"};